import React, { useState, useEffect, useContext } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import DataClient from "../../../../../Service/general_data_service";
import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "../../../../../Components/CustomInput";
import { useDispatch } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    // width: "400px",
    padding: theme.spacing(3),
  },
  title: {
    // textTransform: "initial",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "right",
    "& button": {
      // marginRight: "10px",
    },
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageEvaluationForm(props) {
  const classes = useStyles();
  const {
    action,
    handleClose,
    data,
    fieldAction
  } = props;
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState([]);
  const initialValue = {
    question_type: "Q/A",
    question_name: ""
  }
  const [evaluationData, setEvaluationData] = useState(initialValue)

  const handleChnage = (key, value, index) => {
    if (key === 'question_type') {
      if (value === 'rating') {
        setEvaluationData({ ...initialValue, question_type: value, number_of_star: '', evaluation_rating: [] })
      } else {
        setEvaluationData({ ...initialValue, question_type: value })
      }
    } else if (key === 'number_of_star') {
      const evaluation_ratings = []
      for (let i = 1; i <= +value; i++) {
        const oldvalue = evaluationData?.evaluation_ratings?.length && evaluationData?.evaluation_ratings[i - 1]
        evaluation_ratings.push(oldvalue ? oldvalue : { rating_value: '', star_number: i })
      }
      const newValue = {
        number_of_star: +value,
        evaluation_ratings
      }
      setEvaluationData((oldValue) => ({ ...oldValue, ...newValue }))
    } else if (key === 'evaluation_ratings') {
      const newValue = {
        evaluation_ratings: [...evaluationData.evaluation_ratings.map((item, rIndex) => {
          if (rIndex === index)
            return { ...item, rating_value: value }
          else
            return item;
        })]
      }
      setEvaluationData((oldValue) => ({ ...oldValue, ...newValue }))
    } else {
      setEvaluationData((oldValue) => ({ ...oldValue, [key]: value }))
    }
  }

  const dataObject = {
    question_name: "",
    // default: '',
  };
  const [userData, setUserData] = useState(dataObject);

  useEffect(() => {
    if (Object.keys(data)?.length) {
      const { number_of_star, question_name, question_type, evaluation_ratings } = data;
      setUserData(data);
      setEvaluationData({
        number_of_star, question_name, question_type, evaluation_ratings
      })
    }
  }, [data, data.id]);

  const handleCreate = () => {
    var flag = true;
    if (!evaluationData?.question_name) {
      flag = false;
    }
    if (flag) {
      setSubmitClickFlag(true);
      const statusData = {
        evaluation_form_id: props.evaluationFormId,
        ...evaluationData
      };
      if (evaluationData?.question_type === 'rating')
        statusData.evaluation_rating = JSON.stringify(evaluationData?.evaluation_ratings)
      DataService.createData(statusData, "evaluation_form_fields")
        .then((res) => {
          if (res.success) {
            handleClose(res.data);
            dispatch(showSnackbar("success", ["Success!"]));
            props.getEvaluationForm();
          } else {
            setSubmitClickFlag(true);
            setLoading(false);
          }
        })
        .catch((err) => {
          setErrorMessage(err.errors);
          setLoading(false);
        });
    } else {
      setSubmitClickFlag(true);
    }
  };

  const handleUpdate = () => {
    var flag = true;
    if (userData.section_name === "") {
      flag = false;
    }

    if (flag) {
      setSubmitClickFlag(true);
      const statusData = {
        evaluation_form_id: props.evaluationFormId,
        ...evaluationData
      };
      if (evaluationData?.question_type === 'rating')
        statusData.evaluation_rating = JSON.stringify(evaluationData?.evaluation_ratings)
      DataClient.update(statusData, `/evaluation_form_fields/${data.id}`)
        .then((res) => {
          if (res) {
            // setLoading(true);
            dispatch(showSnackbar("success", ["Success!"]));
            props.getEvaluationForm();
            handleClose();
          } else {
            setSubmitClickFlag(true);
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setSubmitClickFlag(true);
    }
  };


  const handleDeleteFeild = () => {
    setLoading(true);

    DataService.deleteDirectFeild(`/evaluation_form_fields/${data.id}`)
      .then((res) => {
        if (res.success) {
          handleClose(res.data);
          props.getEvaluationForm();
          dispatch(showSnackbar("success", ["Field deleted successfully"]));

          // message.showToastMessage({ open: true, message: "New Supplier added
          // successfully", variant: "success" });   props.getSupplierList();
        } else {
          // message.showToastMessage({ open: true, message: res.errors ?
          // res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
          setLoading(false);
        }
      })
      .catch(() => {
        // message.showToastMessage({ open: true, message: "Something went wrong. Try
        // Again", variant: "error" });
        setLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (action === "create") {
      handleCreate();
    } else if (action === "edit") {
      handleUpdate();
    } else {
      handleDeleteFeild();
    }
  };

  return (
    <div>
      <Dialog
        maxWidth={"sm"}
        style={{
          height: "70%",
        }}
        fullWidth
        open={true}
        // disableBackdropClick
        // disableEscapeKeyDown
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle
          style={{
            paddingTop: "30px",
            paddingLeft: "47px",
            textTransform: "initial"
          }}
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {action === "create" && "Adding new field"}
          {action === "edit" && "Update evaluation field "}
          {fieldAction === "createField" && "Create field"}
          {fieldAction === "editField" && "Update field"}
        </DialogTitle>
        <Divider />
        <DialogContent
          style={{
            margin: "0px auto",
          }}
        >
          {action !== "delete" ? (
            <div className={classes.formWrapper}>
              <Typography
                variant="subtitle2"
                color="secondary"
                className={classes.title}
              ></Typography>
              <form onSubmit={handleSubmit}>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                >
                  <React.Fragment>
                    <Grid item xs={3}>
                      <Typography
                        variant="h2"
                        color="secondary"
                        className={classes.title}
                      >
                        Type of field
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <RadioGroup
                        row
                        aria-label="position"
                        name="rate_type"
                        value={evaluationData?.question_type}
                        onChange={(e) => { handleChnage('question_type', e.target.value); }}
                      >
                        <FormControlLabel
                          value="rating"
                          control={<Radio color="primary" />}
                          label={<Typography variant="h2">Rating</Typography>}
                          labelPlacement="end"
                          disabled={action !== "create" ? true : false}
                        />
                        <FormControlLabel
                          value="Q/A"
                          control={<Radio color="primary" />}
                          label={<Typography variant="h2">Q/A</Typography>}
                          labelPlacement="end"
                          disabled={action !== "create" ? true : false}
                        />
                        <FormControlLabel
                          value="text"
                          control={<Radio color="primary" />}
                          label={<Typography variant="h2">Text field</Typography>}
                          labelPlacement="end"
                          disabled={action !== "create" ? true : false}
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        variant="h2"
                        color="secondary"
                        className={classes.title}
                      >
                        Field name
                      </Typography>
                    </Grid>
                    {/* {popupValue === 'external' && */}
                    <Grid item xs={9}>
                      <CustomInput
                        id="question_name"
                        autoFocus
                        multiline={true}
                        rows={8}
                        helperText={
                          (submitClickFlag &&
                            !evaluationData?.question_name) ? "Please enter section"
                            : ""
                        }
                        error={
                          (submitClickFlag &&
                            !evaluationData?.question_name)
                            ? true
                            : false
                        }
                        parentcall={(value, key) => handleChnage(key, value)}
                        variant="outlined"
                        style={{ backgroundColor: "#fff" }}
                        defaultValue={evaluationData?.question_name}
                        placeholder="Field name"
                      />
                    </Grid>
                    {(evaluationData?.question_type === "rating") && (
                      <React.Fragment>
                        <Grid item xs={3}>
                          <Typography
                            variant="subtitle2"
                            color="secondary"
                            className={classes.title}
                          >
                            Number of stars
                          </Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <TextField
                            style={{ width: "100%" }}
                            id="input-with-icon-grid"
                            // label="Number of stars"
                            placeholder="Number of stars"
                            variant="outlined"
                            name='number_of_star'
                            value={evaluationData?.number_of_star || ''}
                            defaultValue={evaluationData?.number_of_star}
                            onChange={(e) => handleChnage('number_of_star', e.target.value)}
                          />
                        </Grid>
                      </React.Fragment>
                    )}
                    {(evaluationData?.question_type === "rating" && evaluationData?.evaluation_ratings?.length) ? <> {evaluationData.evaluation_ratings.map((row, index) => (
                      <React.Fragment>
                        <Grid item xs={3}>
                          <Typography
                            variant="subtitle2"
                            color="secondary"
                            className={classes.title}
                          >
                            Value for Star {row.star_number}
                          </Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <CustomInput
                            id={row.star_number}
                            parentcall={(value, key) => handleChnage('evaluation_ratings', value, index)}
                            variant="outlined"
                            name="evaluation_ratings"
                            style={{ backgroundColor: "#fff" }}
                            defaultValue={row?.rating_value || ''}
                            placeholder={`Value for star ${row.star_number}`}
                          /></Grid> <br />
                      </React.Fragment>
                    ))}</> : null}
                  </React.Fragment>
                </Grid>

                <div className={classes.actionButtons}>
                  <Button
                    disableElevation
                    disabled={loading}
                    type="button"
                    variant={"contained"}
                    onClick={handleClose}
                    style={{ textTransform: "initial" }}
                  >
                    Cancel
                  </Button> &nbsp;&nbsp;&nbsp;&nbsp;
                  <Button
                    disableElevation
                    disabled={loading}
                    type="submit"
                    variant={"contained"}
                    color="primary"
                    style={{ textTransform: "initial" }}

                  >
                    {action === "create" && "Create"}
                    {action === "edit" && "Update"}
                  </Button>
                </div>
              </form>
            </div>
          ) : (
            <div className={classes.formWrapper}>
              Warning! Deleting this field will delete both the field and
              their type from the list. Are you sure?
              <div className={classes.actionButtons}>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={handleClose}
                  style={{ textTransform: "initial" }}

                >
                  Cancel
                </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  color="primary"
                  onClick={handleDeleteFeild}
                  style={{ textTransform: "initial" }}

                >
                  Yes, confirm
                </Button>
              </div>
            </div>

          )}
        </DialogContent>
      </Dialog>

    </div >
  );
}

export default ManageEvaluationForm;
